<template>
    
        <div class="loading-wrapper" v-bind:style="wrapperStyle">
            <div class="loading-wrapper-inner">
                <double-bounce-spinner v-bind:loading="loading" v-bind:color="color"></double-bounce-spinner>
                <span v-if="branding" class="loading-branding">KMS</span>
            </div>
        </div>
</template>

<script>
    import Vue from 'vue'
    import DoubleBounceSpinner from './double-bounce-spinner'
    
    
    Vue.component('double-bounce-spinner', DoubleBounceSpinner)
    
    export default {

        props: {
            color: {
                type: String,
                default: '#556270'
            },
            loading: {
                type: Boolean,
                default: true
            },
            overlay: {
                type: Boolean,
                default: false
            },
            branding: {
                type: Boolean,
                default: false
            }
            
        },

        data() {
            return {
                wrapperStyle: {
                    backgroundColor: this.overlay ? 'rgba(0,0,0,0.4)' : '',
                    paddingTop: this.branding || this.overlay ? 0 : '50px',
                    paddingBottom: this.branding || this.overlay ? 0 : '50px'
                }
            }
        }
    }
</script>

<style>

    .loading-branding {
        font-family: 'webfont';
        color:#fff;
        font-size:50px;

    }

    .loading-wrapper {
        position: relative;
        left: 0;
        width: 100%;
        height: 100%;
        top: 0;
        
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center
    }

    .loading-wrapper-inner {

    }


    .loading-box {
        /*position: absolute;
        margin: auto;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 200px;
        height: 200px;
        border: 1px solid  #ccc;
        border-radius: 3px;
        font-size: 2.5em;
        text-align: center;*/
        font-style: italic;
        font-weight: 300;
    }


</style>
